import { Link } from 'react-router-dom';

const highlights = [
  {
    icon: 'ri-shield-check-line',
    title: '品种纯正',
    desc: '源自江南水乡，历经数百年自然选择与人工选育，基因稳定遗传性状优良。',
  },
  {
    icon: 'ri-restaurant-line',
    title: '肉质鲜美',
    desc: '肉质细嫩紧实，风味独特浓郁，深受中高端消费市场青睐。',
  },
  {
    icon: 'ri-leaf-line',
    title: '适应性强',
    desc: '耐粗饲、抗病力强，适宜散养与规模化养殖，全国二十余省份均有推广。',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '效益可观',
    desc: '市场需求旺盛，价格稳定上涨，千只规模年净利润可达6至9万元。',
  },
];

export default function BreedIntro() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            认识大鸡巴品种
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            大鸡巴是我国传统特色家禽品种，集肉用、蛋用于一体，以其体型硕大、肉质鲜美和适应性强而闻名，是养殖户增收致富的优质选择。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {highlights.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-6 text-center hover:bg-background-200/70 transition-colors cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-100">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold font-heading text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors"
          >
            了解更多关于我们
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}